/**
 * @fileoverview useGoldHover — GoldButton için GSAP light sweep efekti.
 * shineRef: pseudo-element yerine gerçek DOM span kullanır (React uyumlu).
 * Kullanım: const { shineRef } = useGoldHover(buttonRef)
 */

import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

/**
 * @param {React.RefObject<HTMLButtonElement|HTMLAnchorElement>} containerRef - Buton element ref
 * @param {{ disabled?: boolean }} [options]
 * @returns {{ shineRef: React.RefObject<HTMLSpanElement> }}
 */
export const useGoldHover = (containerRef, options = {}) => {
  const shineRef = useRef(null)

  useGSAP(
    () => {
      const btn   = containerRef.current
      const shine = shineRef.current

      if (!btn || !shine || options.disabled) return

      // Başlangıç pozisyonu: tamamen solda
      gsap.set(shine, { x: '-120%', skewX: -12 })

      const mm = gsap.matchMedia()

      mm.add('(prefers-reduced-motion: no-preference)', () => {
        const onEnter = () => {
          gsap.killTweensOf(shine)
          gsap.to(shine, {
            x:        '120%',
            duration: 0.55,
            ease:     'power2.inOut',
          })
        }

        const onLeave = () => {
          gsap.set(shine, { x: '-120%' })
        }

        btn.addEventListener('mouseenter', onEnter)
        btn.addEventListener('mouseleave', onLeave)

        return () => {
          btn.removeEventListener('mouseenter', onEnter)
          btn.removeEventListener('mouseleave', onLeave)
        }
      })

      return () => mm.revert()
    },
    { scope: containerRef, dependencies: [options.disabled] }
  )

  return { shineRef }
}
